import { getToken } from '@loadsmart/miranda-react/dist/tokens'

export const addPreferredLaneStyles = {
  border: 'none',
  padding: 0,
  gap: getToken('spacing-2'),
}
